import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase.init';
import useUser from '../../hooks/useUser';
import Navbar from '../Shared/Navbar';
import AdminDashboard from './AdminDashboard';
import UserDashboard from './UserDashoard';

const Dashboard = () => {

    const [user, loading] = useAuthState(auth);
    const [userc] = useUser(user?.email);

    return (
        <div>
            <Navbar />
            <div className='w-11/12 lg:w-4/5 mx-auto my-16'>
                <h1 className='text-4xl font-bold my-8'>Sorted By Date</h1>
                {
                    userc?.role === "user" && <UserDashboard />
                }
                {
                    userc?.role === "guide" && <UserDashboard />
                }
                {
                    userc?.role === "admin" && <AdminDashboard />
                }
            </div>
        </div>
    );
};

export default Dashboard;